import script from "./HealthCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./HealthCheck.vue?vue&type=script&setup=true&lang=ts"

import "./HealthCheck.vue?vue&type=style&index=0&id=1911d656&scoped=true&lang=scss"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1911d656"]])

export default __exports__